import { render } from "./TaskBox.vue?vue&type=template&id=256fe99c&scoped=true"
import script from "./TaskBox.vue?vue&type=script&lang=js"
export * from "./TaskBox.vue?vue&type=script&lang=js"

import "./TaskBox.vue?vue&type=style&index=0&id=256fe99c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256fe99c"]])

export default __exports__